import { useState } from 'react';
import { useModuleAccess } from '../organizationStandards/useModuleAccess';
import { downloadReportPdf } from './downloadReportPdf';
import type { ReportType } from './types';

interface ExportPdfButtonProps {
  reportType: ReportType;
  resourceId: string;
  permissionKey: string;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export function ExportPdfButton({
  reportType,
  resourceId,
  permissionKey,
  label = 'Exportar PDF',
  className = 'btn btn-outline',
  disabled = false,
}: ExportPdfButtonProps) {
  const { canAccess } = useModuleAccess();
  const [exporting, setExporting] = useState(false);

  if (!canAccess(permissionKey)) {
    return null;
  }

  const handleClick = async () => {
    setExporting(true);
    try {
      await downloadReportPdf(reportType, resourceId);
    } catch {
      window.alert('No se pudo exportar el informe PDF.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={() => void handleClick()}
      disabled={disabled || exporting}
    >
      {exporting ? 'Exportando…' : label}
    </button>
  );
}
